export default __webpack_public_path__ + "static/skillfactory-15272681c3373b2c118ba39d4d50aed9.png";